// extracted by mini-css-extract-plugin
export var closed = "_bl-1";
export var resizer = "_bl-0";